import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
// import { TableBody, TableRow, TableCell, TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";

import Table from "@mui/material/Table";

import Checkbox from "@mui/material/Checkbox";
import TablePagination from "@mui/material/TablePagination";
import moment from "moment";
// import TablaDetallesAprobacionOrden from "./tablaAgregarAprobaciones";
/* import TablaDetallesAprobaciones from './tablaDetallesAprobaciones'; */
import useTableFijo from "../useTableFijo";
import CatalogoProvFondoTer from "../../catalogos/catalogoProveedorFondoTer";
import {
  EnhancedTableHead,
  formatMoneda,
  getComparator,
  stableSort,
  timeout,
  validaSoloNumero
} from "../../util/varios";

// import { Autocomplete } from "@material-ui/lab";

import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import { Input, Radio, SearchInput, Select, Textarea } from "../../ui/inputs/Input";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";


export const ModalTrasladoFondos = (props) => {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Orden",
      textAlign: "center",
      width: "40px",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Fondo Terceros",
      textAlign: "center",
      width: "130px",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto Orden",
      textAlign: "center",
      width: "110px",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Tipo Retención",
      textAlign: "center",
      width: "130px",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Retenido",
      textAlign: "center",
      width: "100px",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Fecha",
      textAlign: "center",
      width: "100px",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Banco",
      textAlign: "center",
      width: "275px",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Factura",
      textAlign: "center",
    },
  ];

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  let liquidador = JSON.parse(localStorage.getItem("liquidador"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const [order, setOrder] = React.useState("asc");
  // const [order1, setOrder1] = React.useState('asc');
  // const [order2, setOrder2] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState("calories");
  // const [orderBy1, setOrderBy1] = React.useState('calories');
  // const [orderBy2, setOrderBy2] = React.useState('calories');

  const [page, setPage] = React.useState(0);
  // const [page1, setPage1] = React.useState(0);
  // const [page2, setPage2] = React.useState(0);
  const [valret, setValret] = useState();
  // const [selected1, setSelected1] = React.useState([]);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // const [rowsPerPage1, setRowsPerPage1] = React.useState(10);
  // const [rowsPerPage2, setRowsPerPage2] = React.useState(10);
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(true);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  // const [visible, setVisible] = useState("hidden");
  // const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("hola papa");
  const [mostrar5, setMostrar5] = useState(false);
  const [visibleProv, setVisibleProv] = useState("hidden");
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [records, setRecords] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const chkPorFondo = useRef();
  const chKTodoProv = useRef();
  const chkPorBanco = useRef();
  const chKTodoBanco = useRef();
  const cmbBank = useRef();
  const cmbOrdenar = useRef();

  const [codigo, setCodigo] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFecha = useRef();
  const txtIdprov = useRef(0);
  const txtNombreprov = useRef();
  const txtMotivo = useRef();
  const txtMonto = useRef();
  const txtCodigo = useRef();
  const [selected, setSelected] = React.useState([]);
  // const [ordenar, setOrdenar] = useState("ret_tipo");
  const [proveedor, setProveedor] = useState(0);
  // const [cuenta, setCuenta] = useState(0);
  const [cuentasBancarias, setCuentasBancarias] = useState();
  const [visibleBank, setVisibleBank] = useState("hidden");

  const {
    // TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting
  } = useTableFijo(records, headCells, filterFn, 220);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, records.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtMotivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtMotivo.current.focus();
    } else if (chkPorFondo.current.checked && txtNombreprov.current.value === "" && operacion === 1) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar un Fondo de Tercero",
        icono: "informacion",
      });
      txtIdprov.current.focus();
      sigue = false;
    } else if (chkPorBanco.current.checked && cmbBank.current.value === "0" && operacion === 1) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar un banco",
        icono: "informacion",
      });
      cmbBank.current.focus();
      sigue = false;
    } else if (selectedItems.length < 1 && operacion === 1) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar una retención",
        icono: "informacion",
      });
      sigue = false;
    }
    if (sigue) {
      // let datos = [];
      // let datost = [];
      // let validad = [];
      setBody({
        operacion: operacion,
        retenciones: selectedItems,
        idusuar: idusuario,
        concepto: txtMotivo.current.value,
        fechaveri: txtFecha.current.value,
        monto: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de solicitar el traslado?.";
      } else {
        msg = "Esta Seguro de reversar el traslado?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event, cual) => {
    event.preventDefault();
    if (event.target.checked) {
      const newSelecteds = records.map((item) => item);
      setSelected(newSelecteds);
      setSelectedItems(newSelecteds);
      return;
    } else {
      setSelected([]);
      setSelectedItems([]);
    }
  };
  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/cargarsolicitudtrasladofondotercero`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          setValret(response.data[0].valret);
          if (operacion === 1) {
            txtCodigo.current.value
            setMensajesino({
              mostrar: true,
              titulo: "Imprimir.",
              texto: "Desea Imprimir En este Momento la Solicitud de Traslado?",
              icono: "confirmacion",
            });
          } else {
            blanquear();
            props.onHideRenderizar();
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };
  // const seleccionarFila = (item) => (e) => {
  //   e.preventDefault();
  //   setValues(item);
  // };
  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setRecords([]);
    setVisibleBank("hidden");
    setVisibleProv("hidden");
    txtIdprov.value = 0;
    txtNombreprov.value = "";
    cmbOrdenar.value = "ret_tipo";
    cmbBank.value = 0;
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setTitulo("");
    setActivo(true);
    setSelectedItems([]);
    setDeshabilitado(true);
  };
  const imprimir = () => {
    let reporte = "";
    /* if (
      espiritu === 9 ||
      espiritu === 12 ||
      espiritu === 13 ||
      espiritu === 14
    ) {
      reporte = "ForSolicitudTrasladoNumOrden";
    } else {
      reporte = "ForSolicitudTraslado";
    } */
    reporte = "ForSolicitudTrasladoNumOrden";
    let CONDICION = valret;
    let ELABORADO = liquidador;
    window.open(
      op.reportes +
      "/administracionTesoreria?" +
      "reporte=" +
      reporte +
      "&CONDICION=" +
      CONDICION +
      "&efiscal=" +
      idefiscal +
      "&ELABORADO=" +
      ELABORADO,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };
  const handleCloseSi = () => {
    if (mensajesino.titulo === "Imprimir.") {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      let reporte = "";
      /* if (
        espiritu === 9 ||
        espiritu === 12 ||
        espiritu === 13 ||
        espiritu === 14
      ) {
        reporte = "ForSolicitudTrasladoNumOrden";
      } else {
        reporte = "ForSolicitudTraslado";
      } */
      reporte = "ForSolicitudTrasladoNumOrden";
      let CONDICION = valret;
      let ELABORADO = liquidador;
      window.open(
        op.reportes +
        "/administracionTesoreria?" +
        "reporte=" +
        reporte +
        "&CONDICION=" +
        CONDICION +
        "&efiscal=" +
        idefiscal +
        "&ELABORADO=" +
        ELABORADO,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
      if (operacion === 1) {
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "La Solicitud "
            + valret
            + " fue Realizada con Exito!",
          icono: "informacion",
        });
      }
      //props.onHideRenderizar();
    } else {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
  };

  // const BaseDatos = (data) => {
  //   if (data.length > 0) {
  //     setActivo(false);
  //     setValida(1);
  //   } else {
  //     setActivo(true);
  //     setValida(0);
  //   }
  //   setData(data);
  // };

  const seleccionarRegistros = () => {
    setSelected([]);
    let proveedor = "";
    let cuenta = "";
    if (chKTodoBanco.current.checked) {
      cuenta = 0;
    } else {
      cuenta = cmbBank.current.value;
    }

    let ordenar = cmbOrdenar.current.value;

    if (chKTodoProv.current.checked) {
      proveedor = 0;
    } else {
      proveedor = txtIdprov.current.value;
    }

    let endpoint = `${op.conexion}/api/administracion/retencioenstercerofondo?operacion=${operacion}&idefiscal=${idefiscal}&proveedor=${proveedor}&banco=${cuenta}&ordenar=${ordenar}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRetencionesxTraslado = (id) => {
    let endpoint = `${op.conexion}/api/administracion/retencionesxtraslado?idaprobacion=${id}&idefiscal=${idefiscal}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length !== 0) {
            setRecords(response.data);
            setSelectedItems(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (props.operacion === 2 || props.operacion === 4) {
                txtFecha.current.value = moment.utc(response.data[i].fechaaprobacion).format("YYYY-MM-DD");
                txtMotivo.current.value = response.data[i].descripaprobacion === null ? "" : response.data[i].descripaprobacion.trim();
                /* cmbBancos.add(rsc.getString("nombre") == null ? "" : rsc.getString("nombre").trim() + "-" + rsc.getString("cta").trim());
                cmbBancos.select(0); */
                cmbBank.current.value = response.data[i].idcuentabancaria;

                txtNombreprov.current.value = response.data[i].razonsocial === null ? "" : response.data[i].razonsocial.trim() + "-" + response.data[i].cta.trim();
                chkPorFondo.current.checked = true;
                chKTodoProv.current.checked = false;
                txtMonto.current.value = formatMoneda(response.data[i].montototalaprob.toString().replace(",", "").replace(".", ","), ",", ".", 2);
              }

            }
            /* chkPorFondo.current.checked = false;
            chKTodoProv.current.checked = true;
            setVisibleProv("visible");

            seleccionarProveedor2(response.data[0].idproveedor); */
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: `${error}`,
          icono: "error",
        });
      });
  };
  const cambiarOrden = (e) => {
    setRecords([]);
    seleccionarRegistros();
  };

  const cambiarCuenta = (e) => {
    setRecords([]);
    seleccionarRegistros();
  };

  const seleccionarCuentasBancarias = () => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let orden = "idcuentabancaria";
    // const municipioss = [];
    // const idmunicipioss = [];
    // const results = [];
    // const element = [];
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          const newArr = response.data.map((item) => {
            return {
              label: item.nombre + " " + item.cuentabancaria,
              value: item.idcuentabancaria,
            };
          });
          setCuentasBancarias(newArr);
          cmbBank.current.value = newArr[0].value;
          if (props.operacion === 1) {
            seleccionarRegistros();
          }

        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarProveedor = (codigo) => {
    setMostrar5(false);
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";
    let nomid2 = "fondotercero";
    setRecords([]);
    let endpoint = `${op.conexion
      }/api/consulta/modeli2?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${true}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            txtIdprov.current.value = response.data[0].idproveedor;
            txtNombreprov.current.value =
              response.data[0].razonsocial.trim() + " " + response.data[0].rif;
            setProveedor(response.data[0].idproveedor);
            seleccionarRegistros();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o Proveedor/Beneficiario, No esta Registrado!",
              icono: "error",
            });
            txtIdprov.current.value = "";
            txtNombreprov.current.value = "";
          }
          
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarProveedor2 = (codigo) => {
    setMostrar5(false);
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";
    let nomid2 = "fondotercero";

    let endpoint = `${op.conexion
      }/api/consulta/modeli2?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${true}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data[0]) {
            txtIdprov.current.value = response.data[0].idproveedor;
            txtNombreprov.current.value =
              response.data[0].razonsocial.trim() + " " + response.data[0].rif;
            setProveedor(response.data[0].idproveedor);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o Proveedor/Beneficiario, No esta Registrado!",
              icono: "error",
            });
            txtIdprov.current.value = "";
            txtNombreprov.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtNombreprov.current.value = "";
    setRecords([]);
    setSelectedItems([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value);
      }
    }
  };
  const isSelected = (idordenpago) => {
    for (let i = 0; i < selected.length; i++) {
      if (selected[i].idordenpago === idordenpago) {
        return true;
      }
    }
    return null;
  };
  // const [currentTotal, setCurrentTotal] = React.useState(0);
  const handleClick = (event, data) => {
    const { idordenpago } = data;

    let newSelected = [];

    const selectedIndex = selected.indexOf(data);

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, data);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (selectedItems.some((item) => item.idordenpago === idordenpago)) {
      setSelectedItems(
        selectedItems.filter((item) => item.idordenpago !== idordenpago)
      );
    } else {
      setSelectedItems([...selectedItems, data]);
    }
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);

        if (props.operacion !== 1) {
          setValret(props.values.idaprobacion);
          setVisibleProv("visible");
          setVisibleBank("visible");
          seleccionarCuentasBancarias();
          setTimeout(() => {
            seleccionarRetencionesxTraslado(props.values.idaprobacion);
          }, 500);

          setValues(props.values);
          txtFecha.current.value = moment.utc(props.values.fechaaprobacion).format(
            "YYYY-MM-DD"
          );
          
          cmbOrdenar.current.value = "";
        } else {

          setRecords([]);
          if (chkPorBanco.current.checked) {
            seleccionarCuentasBancarias();
          }
          seleccionarRegistros();

          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Modulo de Traslado de Fondos de Terceros</h3>
        <a type="button" onClick={cancelar}>
          salir <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body  className="overflow-auto">
        <Dimmer active={activate}></Dimmer>
        <div className="col-12 d-flex flex-wrap m-0 p-0 justify-content-between align-items-center">
          <div className="col-4 col-lg-2 m-0 p-0 pr-2">
            <Input
              label="Código:"
              name="observacion"
              disabled={true}
              defaultValue={values && values.idaprobacion}
              id="inputDireccion"
              ref={txtCodigo}
            />
          </div>
          <div className="col-4 col-lg-2 m-0 p-0">
            <Input
              label="Fecha:"
              type="date"
              disabled
              defaultValue={moment.utc(fechaSistema).format("DD/MM/YYYY")}
              id="inputDireccion"
              ref={txtFecha}
            />
          </div>
          <div className="col-1 m-0 p-0 pl-2">
            <Radio
              label="Todo"
              onClick={() => {
                setRecords([]);
                txtIdprov.current.value = "";
                txtNombreprov.current.value = "";
                setVisibleProv("hidden");
                seleccionarRegistros();
              }}
              defaultChecked
              disabled={operacion === 1 ? false : true}
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault1"
              ref={chKTodoProv}
            />
          </div>
          <div className="col-1 m-0 p-0">
            <Radio
              label="Por Fondo"
              onClick={() => {
                setVisibleProv("visible");
                setRecords([]);
              }}
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault2"
              disabled={operacion === 1 ? false : true}
              ref={chkPorFondo}
            />
          </div>
          {visibleProv !== "hidden" ?
            <fieldset className="col-6 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none m-0 w-auto fw-bold fw-bold">
                Fondo de Tercero
              </legend>
              <div className="col-4 m-0 p-0">
                <SearchInput
                  label="Código:"
                  onKeyUp={handleProveedor}
                  name="observacion"
                  id="inputDireccion"
                  autoComplete="off"
                  disabled={operacion === 1 ? false : true}
                  onClickButton={() => {
                    setMostrar5(true);
                  }}
                  ref={txtIdprov}
                />
              </div>
              <Input
                disabled={true}
                name="observacion"
                id="inputDireccion"
                ref={txtNombreprov}
              />
            </fieldset>
            : <div className="col-6 m-0 p-0"> </div>}
          <div className="col-12 col-lg-3 p-0 m-0 my-2">
            <Select
              label="Ordenar por:"
              onChange={cambiarOrden}
              ref={cmbOrdenar}
              disabled={operacion === 1 ? false : true}
              options={[
                { label: "TIPO RETENCIÓN", value: "ret_tipo" },
                { label: "N° DE ORDEN", value: "numordenpago" },
                { label: "FECHA DE RETENCIÓN", value: "ret_fecha" },
              ]}
            />
          </div>
          <div className="col-12 col-lg-2 p-2 m-0 my-2">
            <Radio
              label="Todos los Bancos"
              onClick={() => {
                setCuentasBancarias([]);
                setVisibleBank("hidden");
                //seleccionarCuentasBancarias();
                seleccionarRegistros();
              }}
              defaultChecked
              disabled={operacion === 1 ? false : true}
              type="radio"
              name="radiobancos"
              id="todosbanco"
              ref={chKTodoBanco}
            />
          </div>
          <div className="col-12 col-lg-2 p-0 m-0 my-2">
            <Radio
              label="Seleccionar Banco"
              onClick={() => {
                setCuentasBancarias([]);
                setVisibleBank("visible");
                seleccionarCuentasBancarias();
              }}
              disabled={operacion === 1 ? false : true}
              type="radio"
              name="radiobancos"
              id="idbanco"
              ref={chkPorBanco}
            />
          </div>
          {visibleBank !== "hidden" ?
            <div className="col-12 col-lg-5 p-0 pl-lg-2 m-0 my-2 d-flex">
              {/* TODO - AGREGAR ESTO CON EL OPTIONS CUANDO FUNCIONE EL SELECT */}
              <Select
                label="Cuenta Bancaria:"
                onChange={cambiarCuenta}
                disabled={operacion === 1 ? false : true}
                ref={cmbBank}
                options={cuentasBancarias}
              />
            </div>
            : <div className="col-12 col-lg-2 p-0 m-0 my-2"> </div>}
          
          <Paper
            style={{
              width: "100%",
              marginBottom: "10px",
              // Eliminamos maxHeight aquí para que el TableContainer maneje el scroll
              overflow: "hidden",
            }}
          >
            <TableContainer style={{ maxHeight: 300 }}> {/* Altura ajustada para el scroll */}
              <Table
                stickyHeader // Propiedad clave para fijar el header
                style={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size="small"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={records.length}
                  headCells={headCells}
                />
                <TableBody>
                  {stableSort(
                    filterFn.fn(records),
                    getComparator(order, orderBy)
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.idordenpago);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.idordenpago}
                          selected={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              disabled={operacion === 1 ? false : true}
                              color="primary"
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </TableCell>

                          {/* Usamos TableCell en lugar de <td> y aplicamos estilos consistentes */}
                          <TableCell style={{ width: "40px" }} align="center">
                            {row.idordenpago}
                          </TableCell>
                          <TableCell style={{ width: "130px" }} align="center">
                            {row.razonsocial}
                          </TableCell>
                          <TableCell style={{ width: "110px" }} align="right">
                            {formatMoneda(
                              row.montoordenpago
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell style={{ width: "130px" }} align="center">
                            {row.descripcion}
                          </TableCell>
                          <TableCell style={{ width: "100px" }} align="right">
                            {formatMoneda(
                              row.ret_monto
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell style={{ width: "100px" }} align="center">
                            {moment.utc(row.ret_fecha).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell style={{ width: "275px" }} align="left">
                            {row.cuentabancaria
                              ? row.nombre +
                              " " +
                              row.cuentabancaria.replace("-", "")
                              : row.nombre}
                          </TableCell>
                          <TableCell align="left">{row.numfactura}</TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 33 * emptyRows }}>
                      {/* Aumentamos el colSpan a 9 para que ocupe toda la tabla (1 checkbox + 8 columnas) */}
                      <TableCell colSpan={9} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

         

          <div className="col-2 m-0 ml-auto p-0">
            <Input label="Total Pagar:"
              inputClassName='text-end'
              value={formatMoneda(
                selectedItems
                  .reduce((a, b) => parseFloat(a) + parseFloat(b.ret_monto), 0)
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              )}
              name="observacion"
              id="inputDireccion"
              ref={txtMonto}
            />
          </div>
          <div className="col-12 m-0 p-0">
            <Textarea label="Observación:"
              style={{ height: 70 }}
              name="observacion"
              onChange={onChange}
              defaultValue={
                values && values.descripaprobacion
                  ? values.descripaprobacion.trim()
                  : ""
              }
              disabled={
                operacion === 4 || operacion === 2 ? true : false
              }
              id="inputDireccion"
              ref={txtMotivo}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        {operacion !== 1 && (
          <InfoButton onClick={imprimir}>Imprimir</InfoButton>
        )}
        <SuccessButton
          onClick={onChangeValidar}
          disabled={operacion === 1 ? false : deshabilitado}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() => {
          if (mensajesino.titulo === "Imprimir.") {
            setMensajesino({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
            if (operacion === 1) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto: "La Solicitud "
                  + valret
                  + " fue Realizada con Exito!",
                icono: "informacion",
              });
            }
            //props.onHideRenderizar();
          } else {
            setMensajesino({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
          }
        }}
        onHideSi={handleCloseSi}
      />

      <CatalogoProvFondoTer
        show={mostrar5}
        onHideCancela={() => {
          setMostrar5(false);
        }}
        onHideAceptaCatalogo={seleccionarProveedor}
      />
    </Modal>
  );
};
